// see /app/Models/StreamPreset.php
export const VIDEO_TYPE = {
  REPLAY: 'replay', // also called 'rush'
  VOD: 'vod',
  LIVE: 'live',
  CLIP: 'clip',
}
